type SearchPerson = {
	name: string;
	firstName?: string;
	lastName?: string;
};

function includes(value: string | undefined, query: string) {
	return !!value && value.toLocaleLowerCase().includes(query);
}

export function personMatches(person: SearchPerson, query: string) {
	const normalized = query.trim().toLocaleLowerCase();

	if (!normalized) {
		return false;
	}

	return (
		includes(person.name, normalized) ||
		includes(person.firstName, normalized) ||
		includes(person.lastName, normalized)
	);
}

// `function` keeps the row closed. `person` opens it and dims everyone else.
export function matchRewardRow(
	name: string,
	people: SearchPerson[],
	query: string,
): 'function' | 'person' | null {
	const normalized = query.trim().toLocaleLowerCase();

	if (!normalized) {
		return null;
	}

	const functionMatch = includes(name, normalized);
	const personMatch = people.some((person) => personMatches(person, query));

	if (!functionMatch && !personMatch) {
		return null;
	}

	return functionMatch ? 'function' : 'person';
}
